import { Affix, Button, Card, Form, Space } from "antd";
import { EXPORT_DOC_FEE_LIST_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExportDocumentationFeeForm from "../ExportDocumentationFeeForm";

const UpdateExportDocumentationFee = (props) => {
  const { width, viewMode } = props;
  const [editInfo, setEditInfo] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { exportDocFeeId } = useParams();

  const getExportDocFeeInfo = useCallback(
    async (id) => {
      const query = `${EXPORT_DOC_FEE_LIST_ENDPOINT}/${id}`;
      const response = await getData(query);

      if (response && response?.data?.code === 200) {
        const feeData = response?.data?.data;
        form.setFieldsValue({
          name: feeData?.name,
          description: feeData?.description,
        });
        setEditInfo(feeData);
      } else {
        HandleNotification(
          "error",
          "Error!",
          response?.message || "Failed to get export documentation fee data",
        );
      }
    },
    [form],
  );

  useEffect(() => {
    if (exportDocFeeId) {
      getExportDocFeeInfo(exportDocFeeId);
    }
  }, [exportDocFeeId, getExportDocFeeInfo]);

  const discardForm = () => {
    navigate("/import-export-expense-tracking/export-doc-fee");
  };

  const updateExportDocFee = () => {
    form.submit();
  };

  // Download and print functionality can be added later if needed

  const ActionUI = () => {
    return (
      <Space>
        <Button size="small" key={1} danger onClick={() => discardForm()}>
          {viewMode ? "Back" : "Discard"}
        </Button>

        <Button
          size="small"
          key={2}
          type="primary"
          onClick={() => updateExportDocFee()}
          hidden={viewMode}
        >
          Update Export Documentation Fee
        </Button>
      </Space>
    );
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={`${viewMode ? "View" : "Edit"} Export Documentation Fee`}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </Affix>

      <ExportDocumentationFeeForm
        form={form}
        isEdit={true}
        viewMode={viewMode}
        editInfo={editInfo}
      />
    </>
  );
};

export default UpdateExportDocumentationFee;
